import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Download, Link2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PlayerShareCard, usePlayerCardActions } from "@/components/PlayerShareCard";
import { ShareButtons, playerShareText } from "@/components/ShareButtons";

export default function PlayerCardPage() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const ref = useRef(null);
  const { download, copy } = usePlayerCardActions(ref, slug);
  useEffect(() => { api.get(`/players/${slug}/card`).then((r) => setD(r.data)).catch(() => setErr("Player not found")); }, [slug]);

  return (
    <main className="mx-auto flex max-w-3xl flex-col items-center px-4 py-12" data-testid="player-card-page">
      {err && <p className="text-red-400" data-testid="player-card-error">{err}</p>}
      {d && (
        <>
          <PlayerShareCard d={d} innerRef={ref} />
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <button data-testid="player-card-download-btn" onClick={download} className="btn-primary"><Download size={16} /> Download PNG</button>
            <button data-testid="player-card-copy-link-btn" onClick={copy} className="btn-ghost"><Link2 size={16} /> Copy link</button>
          </div>
          <div className="mt-3"><ShareButtons text={playerShareText(d)} url={`${window.location.origin}/p/${slug}`} testPrefix="player-share" /></div>
          <div className="mt-10 text-center">
            <p className="text-sm text-slate-400">{user ? "See every prop, alt line and the model's full record on this player." : "The Parlay Lab tracks how its AI prop calls hit on every player — follow players, ride streaks and build parlays with real win probabilities."}</p>
            <Link to={user ? `/players/${slug}` : "/register"} data-testid="player-card-cta" className="btn-primary mt-4 inline-flex">{user ? "Open player page" : "Get today's picks free"}</Link>
          </div>
        </>
      )}
    </main>
  );
}
